export default __webpack_public_path__ + "static/media/refLayout_1.55c1016b.png";